module.exports = __webpack_public_path__ + "img/CIC.47be56b0.png";